export default __webpack_public_path__ + "static/media/bg3.07b06c00.jpg";